import {engineContext} from './context.js';

(function(g){'use strict';
const VERSION='0.1.0-alpha';

function need(name,method){
  const x=g[name]; if(!x||typeof x[method]!=='function') throw Error(name+'_'+method+'_REQUIRED'); return x;
}
function freeze(v){if(v&&typeof v==='object'&&!Object.isFrozen(v)){Object.freeze(v);Object.values(v).forEach(freeze)}return v;}
function create(opts={}){
  const baseFactory=need('ZooInvestEndToEndResearchRuntime','create');
  const marketEngine=need('ZooInvestMarketDailyCanonicalSnapshot','build');
  const base=baseFactory.create(opts);

  async function run(req={}){
    const r=await base.run(req);
    if(!r.package)return r;

    const raw=r.package?.companyResearch?.marketDaily||null;
    const meta=r.package?.sourceState?.market||null;
    const marketContext=raw?marketEngine.build(raw,{provenance:meta?.provenance||null}):marketEngine.build({symbol:r.symbol,rows:[]});

    const companyResearch=freeze({
      ...(r.package.companyResearch||{}),
      marketContext
    });
    const pkg=freeze({...r.package,companyResearch});

    const ui= r.ui ? freeze({
      ...r.ui,
      marketContext,
      ui:freeze({
        ...(r.ui.ui||{}),
        marketContext
      })
    }) : null;

    return freeze({
      ...r,
      version:VERSION,
      package:pkg,
      ui,
      marketContext,
      execution:freeze({...r.execution,marketDailyCanonicalized:true}),
      guards:freeze({...r.guards,noStaticPriceContextFallback:true})
    });
  }
  return Object.freeze({VERSION,run});
}

async function selfTest(){
  const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});
  const oldBase=g.ZooInvestEndToEndResearchRuntime;
  const oldMarket=g.ZooInvestMarketDailyCanonicalSnapshot;
  try{
    g.ZooInvestEndToEndResearchRuntime={create:()=>({async run(req){
      return {
        version:'old',symbol:req.symbol,status:'READY',
        package:{companyResearch:{marketDaily:{symbol:req.symbol,rows:[
          {date:'2026-08-30',close:100,high:101,low:99,volume:1000},
          {date:'2026-08-29',close:98,high:100,low:97,volume:900}
        ]}},sourceState:{market:{provenance:{provider:'TEST'}}}},
        ui:{symbol:req.symbol,ui:{}},execution:{providerToPackage:true},guards:{}
      };
    }})};
    g.ZooInvestMarketDailyCanonicalSnapshot={build:(raw,meta)=>({
      symbol:raw.symbol,status:raw.rows.length?'READY':'MISSING',
      latest:raw.rows.length?{price:raw.rows[0].close}:null,
      provenance:meta?.provenance||null
    })};

    const api=create(),r=await api.run({symbol:'AAA'});
    ok('base runtime preserved',r.status==='READY');
    ok('market context added',r.marketContext.latest.price===100);
    ok('market context inserted in company research',r.package.companyResearch.marketContext.latest.price===100);
    ok('market context inserted in UI projection',r.ui.ui.marketContext.latest.price===100);
    ok('market provenance forwarded',r.marketContext.provenance.provider==='TEST');
    ok('canonical execution flag true',r.execution.marketDailyCanonicalized===true);
    ok('static fallback forbidden',r.guards.noStaticPriceContextFallback===true);
    ok('old company research preserved',!!r.package.companyResearch.marketDaily);
    ok('no universal score on API',!('score' in api));
    ok('no trade signal on API',!('tradeSignal' in api));
    ok('no capital permission on API',!('capitalPermission' in api));
  } finally {
    g.ZooInvestEndToEndResearchRuntime=oldBase;
    g.ZooInvestMarketDailyCanonicalSnapshot=oldMarket;
  }
  return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}

g.ZooInvestEndToEndResearchRuntimeV405=Object.freeze({VERSION,create,selfTest});
})(engineContext);